export function isError(error: any): error is Error {
    const _err = error as Error;
    return _err?.message !== undefined
}